<template>
  <div>
    <InfoBanner page="my_investments" />
    <div class="investments container">
      <div class="row">
        <div class="col-lg-12">
          <loader v-show="isLoading" />
          <div v-if="!isLoading" class="container">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <before-form-header
                  class="header-table over-header"
                  :title="$t('views.investments.myInvestments')"
                  description=""
                />
                <div class="income-box">
                  <b-button
                    class="btn btn-sm blue-filter"
                    v-b-toggle.sidebar-filters
                    >Filters</b-button
                  >
                  <b-button
                    size="sm"
                    class="income-btn blue-filter"
                    @click="exportToExcel"
                    >{{ $t("views.investments.exportToExcel") }}</b-button
                  >
                  <b-sidebar
                    id="sidebar-filters"
                    class="sdb"
                    title="Filters"
                    shadow
                  >
                    <template #header="{ hide }">
                      <div>
                        <strong id="sidebar-filters___title__">Filters</strong>
                        <div class="right">
                          <button
                            type="button"
                            aria-label="Close"
                            class="close text-dark"
                            @click="hide"
                          >
                            <svg
                              viewBox="0 0 16 16"
                              width="1em"
                              height="1em"
                              focusable="false"
                              role="img"
                              aria-label="x"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              class="bi-x b-icon bi"
                            >
                              <g>
                                <path
                                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                                ></path>
                              </g>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div class="top-row row-no-padding w-100 row col-12">
                        <div
                          class="text-right top-btns"
                          v-show="
                            $store.state.filters.enabledFilters &&
                            $store.state.filters.enabledFilters.length
                          "
                        >
                          <b-button class="clear-filter" @click="resetFilters"
                            ><img src="../assets/clear_filters.svg" alt="" />{{
                              $t("views.investments.resetFilters")
                            }}</b-button
                          >
                          <b-button
                            class="btn apply-filter"
                            @click="applyFilters"
                            >{{
                              $t("views.investments.applyFilters")
                            }}</b-button
                          >
                        </div>
                      </div>
                    </template>
                    <div class="left-filters-section">
                      <div class="right-filters" v-if="showFilters">
                        <div
                          v-for="filter in this.showFilters"
                          v-bind:key="filter.id"
                        >
                          <filter-block
                            :filter="filter"
                            @set-filter="setFilter"
                            :use-enabled-filters="true"
                          ></filter-block>
                        </div>
                      </div>
                    </div>
                  </b-sidebar>
                </div>
                <div class="income-box">
                  <b-table
                    ref="my_invest"
                    hover
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="loadInvestmentsData"
                    :busy="isTableItemsLoading"
                    :fields="tableFields"
                    class="invest-table"
                    responsive="lg"
                  >
                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <loader></loader>
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <span
                        class="table-header"
                        v-b-tooltip.hover
                        :title="$t(data.field.tooltip)"
                        >{{ $t(data.label) }}</span
                      >
                    </template>
                    <template v-slot:cell(country)="{ value }">
                      <img class="flag" :src="getFlag(value)" alt="" />
                    </template>
                    <template v-slot:cell(id)="{ item }">
                      <router-link :to="{ path: '/loan/' + item.loan_ref }"
                        >{{ item.loan_ref }} - {{ item.loan_type }}</router-link
                      >
                    </template>
                    <template v-slot:cell(originator)="{ item }">
                      <a
                        :href="
                          'https://getincome.com/loan-originators/' +
                          (item.loan_originator_name === 'FIN Yritysrahoitus'
                            ? 'fin-yritysrahoitus'
                            : item.loan_originator_name)
                        "
                        target="_blank"
                        >{{ item.loan_originator_name }}</a
                      >
                      <!--                  / {{ item.loan_originator_rating }}-->
                    </template>
                    <template v-slot:cell(created)="{ value }">
                      {{ showDateInDotFormat(value) }}
                    </template>
                    <template v-slot:cell(loan_due_date)="{ value }">
                      {{
                        showDiffInTermFormat(value, new Date().toDateString())
                      }}
                    </template>
                    <template v-slot:head(investment_invest_amount)="data">
                      <span
                        class="text-right table-header"
                        v-b-tooltip.hover
                        :title="$t(data.field.tooltip)"
                        >{{ $t(data.label) }}</span
                      >
                    </template>
                    <template v-slot:cell(investment_invest_amount)="{ value }">
                      <div class="text-right">{{ value | moneyFormatter }}</div>
                    </template>
                    <template v-slot:head(investment_received_amount)="data">
                      <span
                        class="text-right table-header"
                        v-b-tooltip.hover
                        :title="$t(data.field.tooltip)"
                        >{{ $t(data.label) }}</span
                      >
                    </template>
                    <template
                      v-slot:cell(investment_received_amount)="{ value }"
                    >
                      <div class="text-right">{{ value | moneyFormatter }}</div>
                    </template>
                    <template v-slot:cell(loan_status)="{ item }">
                      <div class="">{{ $t(item.loan_status_i18n) }}</div>
                    </template>
                    <template
                      v-slot:head(investment_outstanding_principal)="data"
                    >
                      <span
                        class="text-right table-header"
                        v-b-tooltip.hover
                        :title="$t(data.field.tooltip)"
                        >{{ $t(data.label) }}</span
                      >
                    </template>
                    <template
                      v-slot:cell(investment_outstanding_principal)="{ value }"
                    >
                      <div class="text-right">{{ value | moneyFormatter }}</div>
                    </template>
                    <template v-slot:head(investment_interest_amount)="data">
                      <span
                        class="text-right table-header"
                        v-b-tooltip.hover
                        :title="$t(data.field.tooltip)"
                        >{{ $t(data.label) }}</span
                      >
                    </template>
                    <template
                      v-slot:cell(investment_interest_amount)="{ value }"
                    >
                      <div class="text-right">{{ value | moneyFormatter }}</div>
                    </template>
                    <template v-slot:cell(pdf_link)="{ item }">
                      <a
                        v-if="item.pdf_link"
                        target="_blank"
                        :href="baseApiUrl + item.pdf_link"
                        ><img
                          src="../assets/pdf.svg"
                          alt="Assignment agreement"
                      /></a>
                      <img
                        v-if="item.pdf_not_ready"
                        src="../assets/generating.svg"
                        width="18px"
                        v-b-tooltip.hover
                        :title="$t('views.investments.assignmentAgreementIs')"
                        alt="Assignment agreement is being prepared, try again in couple minutes!"
                      />
                    </template>
                    <template v-slot:cell(show_details)="row">
                      <b-button
                        size="sm"
                        @click="row.toggleDetails"
                        class="toggle-details-btn"
                        variant="light"
                      >
                        {{ row.detailsShowing ? "&#x25B2;" : "&#x25BC;" }}
                      </b-button>

                      <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                      <b-form-checkbox
                        v-model="row.detailsShowing"
                        @change="row.toggleDetails"
                        class="d-none"
                        >{{
                          $t("views.investments.detailsViaCheck")
                        }}</b-form-checkbox
                      >
                    </template>
                    <template v-slot:row-details="row">
                      <b-card>
                        <b-row class="mb-2">
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.strategy") }}</b
                            ><br />{{
                              row.item.strategy_name
                                ? row.item.strategy_name
                                : $t("views.investments.manualStrategy")
                            }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.loanAmount") }}</b
                            ><br />{{
                              row.item.loan_issued_amount_in_eur
                                | moneyFormatterWithCurrency("EUR")
                            }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.loanCurrency") }}</b
                            ><br />{{ row.item.loan_currency }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.loanAmountIn") }}</b
                            ><br />{{
                              row.item.loan_issued_amount
                                | moneyFormatterWithCurrency(
                                  row.item.loan_currency
                                )
                            }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.initialTerm") }}</b
                            ><br />{{
                              showDiffInTermFormat(
                                row.item.loan_due_date,
                                row.item.loan_issued_date
                              )
                            }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.maturityDate") }}</b
                            ><br />{{
                              showDateInDotFormat(row.item.loan_due_date)
                            }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{ $t("views.investments.buyback") }}</b
                            ><br />{{
                              row.item.loan_buyback_guarantee === 1
                                ? $t("views.investments.yes")
                                : $t("views.investments.no")
                            }}</b-col
                          >
                          <b-col sm="2" class="text-sm-right"
                            ><b>{{
                              $t("views.investments.scheduleExtension")
                            }}</b
                            ><br />{{
                              row.item.loan_extendable_schedule === 1
                                ? $t("views.investments.allowed")
                                : $t("views.investments.notAllowed")
                            }}</b-col
                          >
                        </b-row>
                        <b-button
                          class="d-none"
                          size="sm"
                          @click="row.toggleDetails"
                          >{{ $t("views.investments.hideDetails") }}</b-button
                        >
                        <b-button
                          class="loan-details"
                          size="sm"
                          @click="$router.push('/loan/' + row.item.loan_ref)"
                          >{{
                            $t("views.investments.openLoanDetails")
                          }}</b-button
                        >
                      </b-card>
                    </template>
                  </b-table>
                  <div>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import investorInstance from "../config/investor.json";
import Loader from "../components/Loader";
import InfoBanner from "@/components/InfoBanner";
// import LineChart from '../components/LineChart'
// import Stepper from '../components/Stepper'
// import RightChart from '../components/RightChart'
import moneyMixin from "../mixins/money";
import flagMixin from "../mixins/flag";
import dateMixin from "../mixins/date";
import filtersMixin from "../mixins/filters";
import tempInvestments from "../config/tmp_investments.json";
import FilterBlock from "../components/Filter";
import investments from "@/api/investments";
import classificatorDataHelper from "@/helpers/classificatorDataHelper";
import loadingMixin from "../mixins/loading";
import BeforeFormHeader from "@/components/BeforeFormHeader";

export default {
  components: { BeforeFormHeader, FilterBlock, InfoBanner, Loader },
  // components: {Search, FilterBlock, RightChart, Stepper, LineChart, Loader, BeforeFormHeader},
  mixins: [moneyMixin, flagMixin, filtersMixin, dateMixin, loadingMixin],
  data() {
    return {
      investor: investorInstance,
      isLoading: true,
      isTableItemsLoading: false,
      tableFields: [
        { key: "country", label: "", class: "table-header" },
        {
          key: "id",
          label: "views.investments.table.id",
          class: "table-header",
          tooltip: "views.investments.table.idTooltip",
        },
        {
          key: "originator",
          label: "views.investments.table.loanOriginator",
          class: "table-header",
          tooltip: "views.investments.table.loanOriginatorTooltip",
        },
        {
          key: "created",
          label: "views.investments.table.dateOfInvestment",
          class: "table-header",
          tooltip: "views.investments.table.dateOfInvestmentTooltip",
        },
        {
          key: "loan_due_date",
          label: "views.investments.table.remainingTerm",
          class: "table-header",
          tooltip: "views.investments.table.remainingTermTooltip",
        },
        {
          key: "loan_buyback_date",
          label: "views.loan-details.buybackDate",
          class: "table-header",
          tooltip: "views.loan-details.buybackDate",
        },
        {
          key: "loan_investor_interest_rate",
          label: "views.investments.table.interestRate",
          formatter: "showAsPercentages",
          class: "table-header",
          tooltip: "views.investments.table.interestRateTooltip",
        },
        {
          key: "investment_invest_amount",
          label: "views.investments.table.myInvestment",
          class: "table-header  text-right",
          tooltip: "views.investments.table.myInvestmentTooltip",
        },
        {
          key: "investment_outstanding_principal",
          label: "views.investments.table.outstandingPrincipal",
          class: "table-header text-right",
          tooltip: "views.investments.table.outstandingPrincipalTooltip",
        },
        {
          key: "investment_received_amount",
          label: "views.investments.table.principalReceived",
          class: "table-header text-right",
          tooltip: "views.investments.table.principalReceivedTooltip",
        },
        {
          key: "investment_interest_amount",
          label: "views.investments.table.interestEarned",
          class: "table-header text-right",
          tooltip: "views.investments.table.interestEarnedTooltip",
        },
        {
          key: "loan_status",
          label: "views.investments.table.status",
          class: "table-header",
          tooltip: "views.investments.table.statusTooltip",
        },
        {
          key: "pdf_link",
          label: "views.investments.table.pdf",
          class: "table-header",
          tooltip: "views.investments.table.pdfTooltip",
        },
        { key: "show_details", label: "", class: "table-header" },
      ],
      tableItems: tempInvestments,
      baseApiUrl: process.env.VUE_APP_API_BASE_URL,
      strategyId: null,
      totalRows: 20,
      currentPage: 1,
      perPage: 20,
      searchPhrase: "",
      resetFilter: false,
      alreadyClickApply: false,
    };
  },
  computed: {
    isLoaded: function () {
      return !!this.$store.state.filters.filters;
    },
  },
  created() {
    this.strategyId = parseInt(this.$route.query.strategy_id);
  },
  mounted() {
    this.isLoading = !this.loaded;
    this.$root.$emit("shownav", true);
  },
  watch: {
    "$store.state.filters.enabledFilters": {
      handler(enabledFilters) {
        if (
          enabledFilters &&
          enabledFilters.length === 0 &&
          this.alreadyClickApply
        ) {
          this.$refs.my_invest.refresh();
        }
        // console.log('Send filters: ', enabledFilters)
      },
      deep: true,
    },
    loaded: function () {
      this.isLoading = !this.loaded;
    },
  },
  methods: {
    loadInvestmentsData(ctx) {
      let filters = this.$store.state.filters.enabledFilters ?? null;
      if (this.resetFilter) {
        filters = [];
        this.$store.state.filters.enabledFilters = filters;
        this.resetFilter = false;
      }
      if (
        !filters.length &&
        this.strategyId &&
        this.$store.state.filters &&
        this.$store.state.filters.filters &&
        this.$store.state.filters.filters.filters
      ) {
        const strategyFilter = this.$store.state.filters.filters.filters.find(
          (f) => f.name === "Strategy"
        );
        if (strategyFilter) {
          const strategyOption = strategyFilter.options.find(
            (f) => f.value === this.strategyId
          );
          if (strategyOption) {
            const newFilter = {
              id: strategyFilter.id,
              values: [{ value: this.strategyId, name: strategyOption.name }],
            };
            this.setFilter(newFilter);
          }
        }
      }
      const promise = investments.getInvestmentsPage(
        ctx.currentPage,
        filters,
        this.searchPhrase
      );

      return promise
        .then((response) => {
          this.totalRows = response.total;
          response.items.forEach((loan, index, items) => {
            items[index].country = classificatorDataHelper.getShortNameById(
              "COUNTRY",
              loan.loan_country_id
            );
          });
          return this.filterItems(response.items);
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
    },
    setTableItemsLoading(state) {
      this.isTableItemsLoading = state;
    },
    resetFilters() {
      this.resetFilter = true;
      this.strategyId = null;
      this.applyFilters();
      this.enabledFilters = [];
      this.alreadyClickApply = false;
    },
    exportToExcel() {
      const filters = this.$store.state.filters.enabledFilters ?? {};
      const promise = investments.sendExcelRequest(
        this.currentPage,
        filters,
        this.searchPhrase
      );
      promise
        .then((response) => {
          if (response && response.file_link) {
            // console.log(response.file_link)
            window.open(this.baseApiUrl + response.file_link, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    applyFilters() {
      this.alreadyClickApply = true;
      this.$refs.my_invest.refresh();
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.invest-table th,
.invest-table td {
  padding: 0.27rem !important;
}
.invest-table td,
.invest-table thead th {
  max-width: 75px;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #2a96e4;
}
</style>
<style lang="scss" scoped>
.cash {
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 40px;
  font-feature-settings: "liga" off;
  color: #000000;
}

.cash {
  margin-top: 45px;
}

.cash-details {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #000000;

  span {
    color: #9da0a6;
  }
}

.right-col {
  max-width: 328px;
  background: #ffffff;
  border-radius: 4px;
  min-height: 359px;
  text-align: center;
}

.right-cash {
  overflow: hidden;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: left;
  padding: 3px 20px 15px 15px;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #000000;
  }

  .value {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }

  .module {
    .dots {
      float: right;
    }
  }
}

.small-stepper {
  font-size: 11px;
  font-weight: bold;
  line-height: 20px;
  margin: 20px auto 0 3px;
}

.invest-table {
  font-size: 11px !important;
}

.flag {
  width: 16px;
}

.table-header {
  font-style: normal;
  font-weight: bold;
  font-size: 8px;
  line-height: 10px;
  text-align: center;
  text-transform: uppercase;
  color: #9da0a6;
}

.toggle-details-btn {
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  color: #9da0a6;
  background-color: transparent;
  border: none;
}

.loan-details {
  float: right;
  background: #30a7fe;
  border-radius: 14px;
  border-color: transparent;
  font-size: 11px;
}

.top-btns {
  display: inline-block;

  .clear-filter {
    display: inline-flex;
    border: none;
    box-sizing: border-box;
    border-radius: 50px;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
    color: #000000;
    float: right;
    margin: 0 5px 5px;
    background: transparent;
    box-shadow: none;

    img {
      max-width: 25px;
    }
  }
}

.export {
  margin-top: 7px;
}

.header {
  margin-bottom: 12px;
}

.apply-filter {
  background: #30a7fe;
  border: 1px solid #30a7fe;
  color: white;
  border-radius: 50px;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  line-height: 20px;
  margin: 2px;
  box-shadow: none;
}
</style>
